import React, { useState, useEffect } from 'react';
import { useNavModel } from '@/model/navModel';
import { homeService } from './homeService';

interface ICardNumType {
	numArr: number[][],
	prev: string   //"00000"
}

export function HomeCard() {
	const { addNav } = useNavModel(() => []);

	// const [data, setData] = useState<number[][]>([[0], [0, 1], [0, 1, 2], [0, 1, 2, 4], [0, 1, 2, 4, 5]]);
	const [data1, setData1] = useState<ICardNumType>({ numArr: [], prev: "00000" });
	const [data2, setData2] = useState<ICardNumType>({ numArr: [], prev: "00000" });
	const [data3, setData3] = useState<ICardNumType>({ numArr: [], prev: "00000" });
	const [data4, setData4] = useState<ICardNumType>({ numArr: [], prev: "00000" });

	const getNumAll = async () => {
		let { retData: { distinguishNum, filterNum, releaseNum, signNum } } = await homeService.todayStatistics();
		setData1((origin) => {
			let nextNum: string = addZero(Math.abs(releaseNum ?? 0), 5);
			return {
				numArr: getData(origin.prev, nextNum),
				prev: nextNum
			}
		});
		setData2((origin) => {
			let nextNum: string = addZero(Math.abs(releaseNum ?? 0), 5);
			return {
				numArr: getData(origin.prev, nextNum),
				prev: nextNum
			}
		});
		setData3((origin) => {
			let nextNum: string = addZero(Math.abs(distinguishNum ?? 0), 5);
			return {
				numArr: getData(origin.prev, nextNum),
				prev: nextNum
			}
		});
		setData4((origin) => {
			let nextNum: string = addZero(Math.abs(signNum ?? 0), 5);
			return {
				numArr: getData(origin.prev, nextNum),
				prev: nextNum
			}
		});
	}

	let timer: NodeJS.Timeout;

	useEffect(() => {
		getNumAll();
		timer = setInterval(() => {
			getNumAll()
		}, 15000)

		return () => {
			clearInterval(timer);
		}
	}, []);

	// 数字补零
	const addZero = (num: number | string, n: number): string => {
		let len = num.toString().length;
		while (len < n) {
			num = "0" + num;
			len++;
		}
		return `${num}`;
	}

	// 对比数据前后变化
	const getData = (prev: string, next: string) => {
		let listAll: number[][] = [];
		let prevArray = prev.toString().split("");
		let nextArray = next.toString().split("");
		// console.log(11, prevArray);
		// console.log(22, nextArray);
		let listInit = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9];

		for (let i = 0; i < prevArray.length; i++) {
			let prevNumber = parseInt(prevArray[i]);
			let nextNumber = parseInt(nextArray[i]);
			let start = -1;
			let end = -1;

			for (let j = 0; j < listInit.length; j++) {
				if (listInit[j] === prevNumber) {
					start = j;
				}
				if (start !== -1 && listInit[j] === nextNumber) {
					end = j;
					break;
				}
			}
			listAll.push(listInit.slice(start, end + 1));
		}
		return listAll;
	}

	return (
		<>
			<div className="home-card-wrapper" onClick={() => { }}>
				<div className="home-card">
					<span className="home-card-title" >今日发布量</span>
					<div className="home-card-num">
						{
							data1.numArr.map((list, i) => {
								return <div className="num-list-warp" key={i}>
									<div className={`roll roll_${list.length - 1}`}>
										{
											list.map((item, index) => {
												return <div key={index}>
													{item}
												</div>
											})
										}
									</div>

								</div>
							})
						}
					</div>
				</div>
				<div className="home-card" onClick={() => addNav("2")}>
					<span className="home-card-title">今日过滤量</span>
					<span className="home-card-num">
						{
							data2.numArr.map((list, i) => {
								return <div className="num-list-warp" key={i}>
									<div className={`roll roll_${list.length - 1}`}>
										{
											list.map((item, index) => {
												return <div key={index}>
													{item}
												</div>
											})
										}
									</div>

								</div>
							})
						}
					</span>
				</div>
			</div>
			<div className="home-card-wrapper" >
				<div className="home-card" onClick={() => addNav("3-1")}>
					<span className="home-card-title">今日识别量</span>
					<span className="home-card-num">
						{
							data3.numArr.map((list, i) => {
								return <div className="num-list-warp" key={i}>
									<div className={`roll roll_${list.length - 1}`}>
										{
											list.map((item, index) => {
												return <div key={index}>
													{item}
												</div>
											})
										}
									</div>

								</div>
							})
						}
					</span>
				</div>
				<div className="home-card" onClick={() => addNav("3-2")}>
					<span className="home-card-title">今日标记量</span>
					<span className="home-card-num">
						{
							data4.numArr.map((list, i) => {
								return <div className="num-list-warp" key={i}>
									<div className={`roll roll_${list.length - 1}`}>
										{
											list.map((item, index) => {
												return <div key={index}>
													{item}
												</div>
											})
										}
									</div>
								</div>
							})
						}
					</span>
				</div>
			</div></>
	);
}

